module.exports = __webpack_public_path__ + "static/media/reset.5d1ce874.svg";